import axios from 'axios';
import { MinicartCount } from './../../layout/minicart/minicart-count';

class CartAdd {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-add-to-cart',
            onSubmit: null,
            loader: null
        };
        this.settings = Object.assign({}, defaults, options);
        this.$cart = document.querySelector('[data-minicart="root"]');
        this.$addToCart = element;
        this.$addButton = this.$addToCart;
        this.$addItemInput = this.$addToCart.querySelectorAll('[data-add-cart="input"]');
        this.$cartContent = this.$cart.querySelector('[data-add-to-cart="content"]');
        this.$cartWrapper = this.$cart.querySelector('[data-minicart="wrapper"]');
        this.initialize();
    }

    initialize () {
        this.initForm();
    }

    initForm () {
        this.$addToCartButton = this.$addButton.querySelector('[data-add-to-cart="button"]');
        this.$addToCartButton.addEventListener('click', (e) => {
            const formMethod = this.$addToCart.getAttribute('method');
            const formAction = this.$addToCart.getAttribute('action');
            const formData = new FormData(this.$addToCart);
            axios({
                method: formMethod,
                url: formAction,
                data: formData
            })
                .then((response) => {
                    if (typeof response.data.action !== 'undefined' && typeof response.data.content !== 'undefined') {
                        if (response.data.action === 'render') {
                            const div = document.createElement('div');
                            div.innerHTML = response.data.content;
                            if (this.$cartContent !== null) {
                                const responseContent = div.querySelector('[data-add-to-cart="content"]');
                                const cartAmount = div.querySelector('[data-minicart-count]');
                                const count = new MinicartCount();
                                this.$cartContent.innerHTML = responseContent.innerHTML;
                                this.$cart.classList.add('minicart--is-active');
                                this.$cart.classList.add('minicart--is-open-from');

                                this.showMinicartContent();
                                // update item counter in minicart
                                count.updateCountIndicator(cartAmount.getAttribute('data-minicart-count'));
                            }

                            if (typeof this.settings.onSubmit === 'function') {
                                this.settings.onSubmit(this.$addToCart);
                                this.settings.onSubmit(this.$cartContent);
                            }
                        }

                        if (response.data.action === 'productNotAllowed') {
                            const url = new URL(window.location);
                            window.location.href = url.toString();
                        }
                    }
                })
                .catch((error) => {
                    throw Error(error);
                });

            e.preventDefault();
        });
    }

    showMinicartContent () {
        // show add to cart icon
        this.$addToCartButton.classList.add('product-item__add-to-cart--is-added');

        // skip shows cart when hover on minicart
        let skipTimeout = false;

        // still shows the minicart when user hovered over it during timeout
        this.$cart.addEventListener('mouseenter', () => {
            skipTimeout = true;
        });

        // close minicart when mouse leaves content
        this.$cart.addEventListener('mouseleave', () => {
            this.$cart.classList.remove('minicart--is-active');
            this.$cart.classList.remove('minicart--is-open-from');
        });

        // shows minicart after "product add" for 1.5 seconds
        setTimeout(() => {
            this.$addToCartButton.classList.remove('product-item__add-to-cart--is-added');

            if (!skipTimeout) {
                this.$cart.classList.remove('minicart--is-active');
                this.$cart.classList.remove('minicart--is-open-from');
            }
        }, 2000);
    }
}

export { CartAdd };
